import { Navigate } from "react-router";
import { useGetTimberClassQuery } from "../../../apis/TimberClass.api";
import { PrimaryTimberClass, TimberClass } from "../../../types/models/TimberClass";
import GradientCircularProgress from "../../../../share/components/progress/GradientCircularProgress";

export const TimberClassScoped = () => {
    const {
        data,
    } = useGetTimberClassQuery(PrimaryTimberClass.fromPath('scoped'))

    if (data) {
        const url = `/dashboard/timber-classes/${data.id}?scoped=true`
        return <Navigate to={url} replace/>
    } else {
        return <>
            <GradientCircularProgress/>
        </>
    }
}
export default TimberClassScoped;
